export default "__VITE_ASSET__5402fc7e__"